<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="checkmark-circle-1"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="Group_868" data-name="Group 868">
      <path
        id="Path_8197"
        data-name="Path 8197"
        d="M12,3a9,9,0,1,0,9,9,9,9,0,0,0-9-9Z"
        fill="none"
        :stroke="clr ? clr : '#fff'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_8198"
        data-name="Path 8198"
        d="M8.44,12.339l2.167,2.167-.02-.02,4.88-4.89"
        fill="none"
        :stroke="clr ? clr : '#fff'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <path id="Path_8199" data-name="Path 8199" d="M0,0H24V24H0Z" fill="none" />
  </svg>
</template>
